import { secondsInDay } from "date-fns"
import { TemplateTypeStudyReminder } from "../api/types/messages"
import { AutoMessageRecipe } from "../components/messages/Automessages"

export const useAutomessageRecipes = (): AutoMessageRecipe[] => {
    return [
        {
            label:'Weekly reminder',
            recipe: {
                label:'weekly',
                period: secondsInDay,
                nextTime: {next: {day:'monday', 'hour': 13, 'minute': 0}},
                until: {next: {day: 'sunday', hour: 14, 'minute': 0}},
                type: 'all-users'
            }
        },
        {
            label:'Test for Weekly reminder',
            recipe: {
                label:'weekly test',
                period: secondsInDay * 365 * 20, // In far future
                nextTime: {in: {minutes: 1}},
                until: {in: {minutes: 10}},
                condition: {
                    dtype:'exp',
                    exp: {
                        name: 'hasParticipantFlag',
                        data: [
                            {'str': 'reminderTester'},
                            {'str': '1'}
                        ]
                    }
                },
                studyKey: 'grippenet',
                type: 'study-participants'
            },
            forceTemplateType: TemplateTypeStudyReminder,
        },
        {
            label:'Sisp & EAU Bas-Rhin',
            recipe: {
                label:'Sisp & Eau, Bas-Rhin',
                period: secondsInDay * 365 * 20, // In far future
                nextTime: {in: {minutes: 1}},
                until: {in: {minutes: 10}},
                condition: {
                    dtype:'exp',
                    exp: {
                        name: 'hasParticipantFlag',
                        data: [
                            {'str': 'sispo'},
                            {'str': 'B'}
                        ]
                    }
                },
                studyKey: 'grippenet',
                type: 'study-participants'
            },
            forceTemplateType: TemplateTypeStudyReminder,
        },
        {
            label:'Sisp & EAU Alpes Maritimes',
            recipe: {
                label:'Sisp & Eau, Alpes Maritimes',
                period: secondsInDay * 365 * 20, // In far future
                nextTime: {in: {minutes: 1}},
                until: {in: {minutes: 10}},
                condition: {
                    dtype:'exp',
                    exp: {
                        name: 'hasParticipantFlag',
                        data: [
                            {'str': 'sispo'},
                            {'str': 'A'}
                        ]
                    }
                },
                studyKey: 'grippenet',
                type: 'study-participants'
            },
            forceTemplateType: TemplateTypeStudyReminder,
        },
        {
            label:'Sisp & EAU Toutes zones',
            recipe: {
                label:'Sisp & Eau,  Toutes zones',
                period: secondsInDay * 365 * 20, // In far future
                nextTime: {in: {minutes: 1}},
                until: {in: {minutes: 10}},
                condition: {
                    dtype:'exp',
                    exp: {
                        "name": "and",
                        "data": [
                            {
                                "dtype": "exp",
                                "exp": {
                                    "name": "hasParticipantFlagKey",
                                    "data": [
                                        {
                                            "dtype": "str",
                                            "str": "sispo"
                                        }
                                    ]
                                }
                            },
                            {
                                "dtype": "exp",
                                "exp": {
                                    "name": "not",
                                    "data": [
                                        {
                                            "dtype": "exp",
                                            "exp": {
                                                "name": "hasParticipantFlag",
                                                "data": [
                                                    {
                                                        "dtype": "str",
                                                        "str": "sispo"
                                                    },
                                                    {
                                                        "dtype": "str",
                                                        "str": ""
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                },
                studyKey: 'grippenet',
                type: 'study-participants'
            },
            forceTemplateType: TemplateTypeStudyReminder,
        }
    ]
}

